// Mock data for Sassy Full Stack Fitness landing page
// NOTE: All data below is MOCKED for the frontend-only teaser.
// Before/After client photos are placeholders — user will provide real photos in later stages.

export const brand = {
  name: "Sassy Full Stack Fitness",
  year: 2026,
};

export const coachImage =
  "https://customer-assets-v7afamib.emergentagent.net/job_facfc8de-09c6-40f9-b535-c72cf9b6acc1/artifacts/k60oa567_1.webp";

export const hero = {
  eyebrow: "For women who used to feel great",
  titlePlain: "Remember When You Felt Strong, Lean & Full of Energy? ",
  titleGold: "Get Her Back.",
  sub: "Answer 4 quick questions and get your free custom 6-week fitness plan, delivered immediately — built to bring back the version of you that felt great, at the age you are now.",
  cta: "Take the 60-Second Quiz →",
  note: "Free · Takes about a minute · Your plan is ready instantly",
};

export const proofStats = [
  { num: "300+", lbl: "Women Coached" },
  { num: "6 Weeks", lbl: "To Visible Results" },
  { num: "4.9★", lbl: "Client Rating" },
];

export const clientImage1 =
  "https://customer-assets-jt897jd0.emergentagent.net/job_custom-landing-14/artifacts/3ce8pdx9_Screenshot_20260809_122644_Gmail.webp";

export const clientImage2 =
  "https://customer-assets-jt897jd0.emergentagent.net/job_custom-landing-14/artifacts/u58znc6l_Screenshot_20260809_120353_Instagram.jpg";

export const clientImage3 =
  "https://customer-assets-jt897jd0.emergentagent.net/job_custom-landing-14/artifacts/l1s799he_Sherry.png";

export const clientImage4 =
  "https://customer-assets-jt897jd0.emergentagent.net/job_custom-landing-14/artifacts/4rja0owh_Ashley.png";

export const testimonials = [
  {
    id: "client3",
    image: clientImage3,
    contain: true,
    label: "[ Client Photo ]",
    chip: "Not a gym person",
    quote:
      "I started in my mid-50s — not athletic, definitely not a gym person. Sandra met me where I was, and two and a half years later I'm stronger and more confident in my body than I ever imagined I'd be.",
    who: "Sherry Jacques, 57 · Retired Attorney",
  },
  {
    id: "client4",
    image: clientImage4,
    contain: true,
    label: "[ Client Photo ]",
    chip: "Lost 10 lbs with real muscle tone",
    quote:
      "In six months I lost 10 pounds, gained real muscle tone, and my posture is noticeably better. Sandra followed every single workout and every question — and the habits she built with me have stuck ever since.",
    who: "Ashley Meadows, 58 · Fitness Instructor in the '90s",
  },
  {
    id: "client2",
    image: clientImage2,
    contain: true,
    label: "[ Client Photo ]",
    chip: "Muscle growth achieved",
    quote:
      "The muscle growth and transformation of my body has surpassed my expectations. Trusting Sandra's wisdom — and letting go of old patterns — changed me on the inside too.",
    who: "Mary Helen Richards, 62 · Muscle & Mindset",
  },
  {
    id: "client1",
    image: clientImage1,
    contain: true,
    label: "[ Client Photo ]",
    chip: "Stronger & healthier at 74",
    quote:
      "I walked out of my doctor's office discouraged at 73. A year later I'm stronger, my labs have improved, and I'm proud of what we accomplished. Sandra has been a true blessing — and she can be yours too.",
    who: "Cynthia Nowell, 73 · Strength & Longevity",
  },
];

export const steps = [
  {
    n: 1,
    title: "Take the Quiz",
    text: "4 quick questions about your goal, your age, and what's held you back before.",
  },
  {
    n: 2,
    title: "Get Your 6-Week Plan",
    text: "A custom fitness roadmap — training, nutrition targets, and recovery, built around your goal and your real life.",
  },
  {
    n: 3,
    title: "Free Strategy Call",
    text: "Get on a free 15-minute call with a coach to see how coaching with Sandra turns this plan into real, lasting results — through menopause and beyond.",
  },
];

export const menopause = {
  eyebrow: "For women navigating the change",
  title: "Menopause Didn't Break You — ",
  titleGold: "Your Old Playbook Did",
  body:
    "Peri-, meno-, and post-menopause change how your body responds to food, training, and stress. The plans that worked in your 30s stop working — and it's not your fault. Your custom plan is built for the hormones you have now.",
  quote:
    "There are two types of women who beat menopause and become the healthiest and best in shape they've ever been — those who have the right coach, and those who will have the right coach.",
  quoteAttr: "— Sandra, Sassy Full Stack Fitness",
};

export const finalCta = {
  titlePlain: "Your Custom 6-Week Plan Is ",
  titleGold: "One Minute Away",
  sub: "Answer 4 quick questions and see exactly what your next 6 weeks should look like.",
  cta: "Start the 60-Second Quiz →",
  note: "Free · No credit card · Instant results",
};

export const fullStack = {
  eyebrow: "The Full Stack difference",
  title: "One Team. One Roof. ",
  titleGold: "Your Whole System.",
  intro:
    "When was the last time your doctor talked to your trainer — or your hormone specialist to your nutritionist? For most women, menopause is treated in fragments. Sassy is Full Stack: seven connected pillars, managed as one system.",
  pillars: [
    { name: "Nutrition", pct: "25%", icon: "Utensils" },
    { name: "Hormonal Health", pct: "20%", icon: "Activity" },
    { name: "Metabolic Health", pct: "20%", icon: "Flame" },
    { name: "Resistance Training", pct: "15%", icon: "Dumbbell" },
    { name: "Rest & Recovery", pct: "10%", icon: "Moon" },
    { name: "Gut Health", pct: "5%", icon: "Leaf" },
    { name: "Cardiovascular", pct: "5%", icon: "Heart" },
  ],
  splitLine:
    "About 60% is what world-class coaching delivers — nutrition, training, recovery, gut and cardiovascular health. The other 40% — your hormones and metabolism — is where menopause is truly won, handled with our vetted medical & lab providers and FDA-regulated pharmacy partners.",
  services: [
    "Lab Testing",
    "Hormone Optimization",
    "Medical Weight Loss",
    "Peptides",
    "Supplements",
    "Personal Coaching",
  ],
};
